<template>
  <div class="main print-no-padding">
    <h2 class="is-print-hide title-area">
      <span class="main-title">消息中心</span>
      <div class="handler-area">
        <div class="submit global_common_button_main btn" v-if="mode == 2" @click="submit()">
          <span>已读</span>
        </div>
        <div class="cancle global_common_button_goast btn" v-if="mode == 2" @click="changeMode(1)">
          <span>取消</span>
        </div>
        <div class="setting btn global_common_button_goast" v-if="mode == 1" @click="changeMode(2)">
          <span>编辑</span>
        </div>
      </div>
    </h2>
    <div class="list-content">
      <div class="list-area">
        <div class="messageList">
          <div class="nullData" v-if="messageCenterList.length == 0">
            <img :src="require('@/assets/img/messagenull.jpg')" alt="" />
            <p>暂无消息</p>
          </div>
          <ul>
            <li v-for="item in messageCenterList" :key="item.id" class="item" @click="handMessage(item)">
              <div class="box">
                <div class="message_checkbox" v-if="mode == 2">
                  <cB :item="item" :selectList="selectList" @change="selectOne"></cB>
                </div>
                <div class="messageMain">
                  <div class="circle" v-show="item.status == 0"></div>
                  <div class="title">{{ item.title }}</div>
                  <div class="text">
                    <span class="content">
                      {{ item.content }}
                    </span>
                    <span class="createTime">{{ renderTime(item.createTime) }}</span>
                  </div>
                </div>
                <div class="messageHander" @mouseenter="iconChange(1)" @mouseleave="iconChange(2)">
                  <span v-if="item.type == 1">点击处理</span>
                  <span v-if="item.type == 2">点击查看</span>
                  <span v-if="item.type == 3">点击查看</span>
                  <span v-if="item.type == 10">点击处理</span>
                  <img :src="icon" alt="" />
                </div>
              </div>
              <div class="line"></div>
            </li>
          </ul>
        </div>
        <div class="footer">
          <div class="selectAll" v-if="mode == 2">
            <el-checkbox v-model="checked" @change="selectAll">全选</el-checkbox>
          </div>
          <skinny-pagination
            :page-no="messageListParams.pageNo"
            @on-change="handleCurrentChange"
            :is-end="!hasNextPage"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from 'dayjs';
import { Pagination, Checkbox } from 'element-ui';
import Vue from 'vue';
import cB from '@/components/messageCenter/checkbox';
import SkinnyPagination from '@/components/skinnyPagination';
import store from '@/store';

Vue.use(Pagination);
Vue.use(Checkbox);
const icon1 = require('@/assets/img/btn_next_green_pre.png');
const icon2 = require('@/assets/img/btn_next_green_xuanfu.png');
export default {
  components: { cB, SkinnyPagination },
  data() {
    return {
      messageListParams: {
        pageNo: 1,
        pageSize: 10
      },
      icon: icon1,
      mode: 1,
      checked: false,
      selectList: [],
      hasNextPage: false
    };
  },
  mounted() {
    this.init();
  },
  computed: {
    messageCenterList() {
      return this.$store.getters.messageCenterList;
    }
  },
  methods: {
    async submit() {
      // 已读消息
      const messageIds = this.selectList.map(v => {
        return v.id;
      });
      try {
        let res = await Fetch.readMessage({ messageIds });
        store.dispatch('messageCenter/GetmessageCenterNotification');
        this.$message({
          message: '操作成功',
          type: 'success'
        });
        this.mode = 1;
        this.clearSelectList();
        this._messageCenterList();
      } catch (error) {}
    },
    clearSelectList() {
      this.selectList = [];
      this.checked = false;
    },
    selectOne({ item, ifCheck }) {
      // 单选
      const { id } = item;
      item.ifCheck = ifCheck;
      const { selectList } = this;
      let index = null;
      selectList.filter((v, i) => {
        if (v.id == id) {
          index = i;
        }
      });
      if (!index) {
        // 该元素不在列表中
      } else {
        // 先移除该元素
        this.selectList.splice(index, 1);
        if (ifCheck === false) {
          return;
        }
      }
      this.selectList.push(item);
    },
    selectAll(value) {
      if (value == false) {
        this.clearSelectList();
      }

      // 全选、或者反选当前列表
      const { messageCenterList, selectList } = this;
      const filtermessageCenterList = messageCenterList.filter(v => {
        if (v.status == 0) {
          v.ifCheck = value;
          return v;
        }
      });
      this.selectList = [...filtermessageCenterList];
    },
    changeMode(m) {
      if (m == 1) {
        this.mode = 1;
        this.clearSelectList();
        return;
      }
      this.mode = 2;
    },
    iconChange(t) {
      if (t == 1) {
        this.icon = icon2;
      } else {
        this.icon = icon1;
      }
    },
    handleCurrentChange(val) {
      this.messageListParams.pageNo = val;
      this._messageCenterList();
      this.clearSelectList();
    },
    init() {
      this._messageCenterList();
    },
    async _messageCenterList() {
      // 获取消息列表
      const params = {
        pageNo: this.messageListParams.pageNo,
        pageSize: this.messageListParams.pageSize
      };
      let res = await Fetch.messagesPageV2({ ...params });
      this.hasNextPage = res.hasNextPage;
      this.$store.dispatch('messageCenter/SETmessageCenterList', res.data);
    },
    renderTime(timetip) {
      return dayjs(timetip).format('YYYY-MM-DD HH:mm');
    },
    async handMessage(item) {
      const { type, id } = item;
      try {
        let res = await Fetch.readMessage({ messageIds: [id] });
        store.dispatch('messageCenter/GetmessageCenterNotification');
        this._messageCenterList();
      } catch (error) {}
      if (type == 1) {
        this.$router.push('/waitPrescriptionList');
        return;
      }
      if (type == 2) {
        this.$router.push('/shopManagement');
        return;
      }
      if (type == 3) {
        this.$router.push('/shopManagement');
        return;
      }
      if (type == 10) {
        return this.$router.push('/drugsManagement');
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.nullData {
  padding-top: 50px;
  img {
    display: block;
    width: 272px;
    margin: 0 auto;
  }
  p {
    text-align: center;
  }
}
.title-area {
  overflow: hidden;
  padding-bottom: 10px;

  .main-title {
    float: left;
    line-height: 40px;
  }
  .handler-area {
    overflow: hidden;
    .setting {
    }
    .add-story {
      // background: #ebb436;
      // &:hover {
      //   background: rgba(255, 195, 59, 1);
      // }
      // span {
      //   color: #fff;
      // }
    }
    .btn {
      width: 132px;
      height: 40px;
      float: right;
      line-height: 40px;
      text-align: center;
      margin-right: 16px;
      border-radius: 4px;
      cursor: pointer;
      span {
        font-size: 14px;
      }
    }
  }
  .cancle {
  }
  .submit {
  }
}
.list-content {
  background: #ffffff;
  border: 1px solid #f2f2f2;
  box-shadow: 0 4px 12px 0 #ededed;
  border-radius: 4px;
  // padding: 16px;
  padding-bottom: 16px;
  min-height: 600px;
  .list-area {
    .messageList {
      min-height: 600px;
      padding-bottom: 16px;
      .item {
        cursor: pointer;
        &:hover {
          background: #fafafa;
        }

        padding: 15px 16px 0;
        // border-bottom: 1px solid #f2f2f2;
        .box {
          &:after {
            content: '.';
            display: block;
            height: 0;
            clear: both;
            visibility: hidden;
          }
        }
        .line {
          border-bottom: 1px solid #f2f2f2;
          padding-bottom: 15px;
        }
        .message_checkbox {
          float: left;
          margin-right: 18px;
        }
        .messageMain {
          float: left;
          position: relative;
          .circle {
            position: absolute;
            width: 8px;
            height: 8px;
            background: #e0514c;
            border-radius: 50%;
            left: -10px;
            top: 1px;
            border: 1px solid #fff;
          }
          .title {
            color: #242424;
            font-size: 16px;
            padding-bottom: 2px;
          }
          .text {
            font-size: 14px;
            color: #707070;
            .content {
            }
            .createTime {
              margin-left: 12px;
            }
          }
        }
        .messageHander {
          float: right;
          margin-top: 15px;
          display: flex;
          align-items: center;
          &:hover {
            span {
              color: #4dd168;
            }
          }
          span {
            color: #1e8dff;
            font-size: 14px;
            cursor: pointer;
          }
          img {
            width: 6px;
            margin-left: 6px;
            position: relative;
            top: -1px;
          }
        }
      }
    }
    .footer {
      overflow: hidden;
      display: flex;
      justify-content: center;
      position: relative;
      .selectAll {
        position: absolute;
        left: 16px;
        top: 50%;
        transform: translateY(-50%);
      }
      .sureJump {
        // float: left;
        width: 80px;
        height: 32px;
        // color: #1E8DFF;
        // background: #ffffff;
        // border: 1px solid #1E8DFF;
        border-radius: 3px;
        text-align: center;
        line-height: 32px;
        cursor: pointer;
        margin-left: 10px;
        margin-top: 22px;
      }
      .disabled_page {
        position: absolute;
        display: flex;
        align-items: center;
        right: 20px;
        top: 30px;
        cursor: pointer;
      }
    }
  }
}
</style>
